import React from "react";
import { NavLink } from "react-router-dom";
import { AppendIfPrefixExists } from "../modules/sitePaths";
import { clearImpersonateAndReturnToCs } from "functions/handleImpersonateAccount";
import { useProvisioningData } from "../api/useProvisioningData";
import LoadingOrError from "./LoadingOrError";
import Loading from "../components/Loading";
import ShiOneLogo from "../../../shared-ui/src/components/ShiOneLogo";
import { Link, Typography } from "@mui/material";
import AuthPageContainer from "./AuthPageContainer";
import { isImpersonatingUser } from "shared-ui/src/utils/clientmanagement";

export default function ErrorPage() {
  const { data: provisioningData, isLoading, isError } = useProvisioningData();

  if (isLoading) {
    return <Loading />;
  }

  if (isError || !provisioningData) {
    return <LoadingOrError error message={"Please log out and try again"} />;
  }

  if (provisioningData.responseStatus === 1) {
    window.location.href = AppendIfPrefixExists("/");
    return null;
  }

  const isImpersonating = isImpersonatingUser();
  const waitingApprovalWithAdmins =
    provisioningData.responseStatus === 6 &&
    (provisioningData.myAdmins?.length ?? 0) > 0;

  return (
    <AuthPageContainer>
      <ShiOneLogo />
      <div>
        <h4>{provisioningData.errorMessage}</h4>

        {isImpersonating && (
          <div style={{ marginBottom: "25px" }}>
            <a
              onClick={() => clearImpersonateAndReturnToCs()}
              href="#0"
              className="landing-btn"
            >
              Return to your SHI Account
            </a>
          </div>
        )}

        {provisioningData.responseStatus === 9 && (
          <div>
            <p>
              If you don&#39;t hear from our Support Services within one
              business day, please contact us at{" "}
              <Link href="mailto:SupportServices@shi.com">
                SupportServices@shi.com
              </Link>
              .
            </p>
          </div>
        )}

        {waitingApprovalWithAdmins && (
          <div>
            <ul
              style={{
                paddingLeft: 0,
                listStyle: "none",
                textAlign: "center",
              }}
            >
              {provisioningData.myAdmins?.map((a, k) => {
                return <li key={k}>{a}</li>;
              })}
            </ul>
            <p>
              If none of these users are available please contact{" "}
              <Link href="mailto:SupportServices@shi.com">
                SupportServices@shi.com
              </Link>{" "}
              for support.
            </p>
          </div>
        )}

        {provisioningData.responseStatus === 6 &&
          !waitingApprovalWithAdmins && (
            <div>
              <p>
                Please contact{" "}
                <Link href="mailto:SupportServices@shi.com">
                  SupportServices@shi.com
                </Link>{" "}
                to set up your account.
              </p>
            </div>
          )}

        {!isImpersonating && provisioningData.responseStatus === 5 && (
          <div style={{ marginBottom: "25px" }}>
            <NavLink
              to={AppendIfPrefixExists("/register")}
              className="landing-btn"
            >
              Update Profile
            </NavLink>
          </div>
        )}

        {!isImpersonating && provisioningData.responseStatus !== 5 && (
          <>
            <hr />
            <Typography>
              If you think you may have logged in with the wrong account, you
              can <Link href="/logout">log out</Link> and log back in with
              another account.
            </Typography>
          </>
        )}
        <div>
          <span style={{ fontStyle: "italic" }}>
            Message Code {provisioningData.responseStatus}
          </span>
        </div>
      </div>
    </AuthPageContainer>
  );
}
